/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllReferralCareAttributes200ResponseDataInner } from './FindAllReferralCareAttributes200ResponseDataInner';
import {
    FindAllReferralCareAttributes200ResponseDataInnerFromJSON,
    FindAllReferralCareAttributes200ResponseDataInnerFromJSONTyped,
    FindAllReferralCareAttributes200ResponseDataInnerToJSON,
} from './FindAllReferralCareAttributes200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllReferralCareAttributes200Response
 */
export interface FindAllReferralCareAttributes200Response {
    /**
     * 
     * @type {Array<FindAllReferralCareAttributes200ResponseDataInner>}
     * @memberof FindAllReferralCareAttributes200Response
     */
    data?: Array<FindAllReferralCareAttributes200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllReferralCareAttributes200Response interface.
 */
export function instanceOfFindAllReferralCareAttributes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllReferralCareAttributes200ResponseFromJSON(json: any): FindAllReferralCareAttributes200Response {
    return FindAllReferralCareAttributes200ResponseFromJSONTyped(json, false);
}

export function FindAllReferralCareAttributes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllReferralCareAttributes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FindAllReferralCareAttributes200ResponseDataInnerFromJSON)),
    };
}

export function FindAllReferralCareAttributes200ResponseToJSON(value?: FindAllReferralCareAttributes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FindAllReferralCareAttributes200ResponseDataInnerToJSON)),
    };
}

